import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Box } from "@mui/material";

export default function CarrosselImages({ imagens }) {
  return (
    <Box sx={{ width: "100%", margin: "0 auto" }}>
      <Swiper
        modules={[Pagination, Navigation, Autoplay]}
        pagination={{ clickable: true }}
        navigation
        spaceBetween={10}
        slidesPerView={1}
        loop={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        }}
        style={{ borderRadius: 10 }}
      >
        {imagens.map((src, index) => (
          <SwiperSlide key={index}>
            <img
              src={src}
              className="mySwiper"
              alt="foto"
              style={{
                width: "100%",
                height: "auto",
                borderRadius: 10,
                objectFit: "cover",
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
}
